import { siteName, privacyEmail } from 'config/site';
import React from 'react';
import { Box, Container, Typography, Paper, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const Privacy = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'background.default', py: 4 }}>
      <Container maxWidth="md">
        <Button
          startIcon={<ArrowBackIcon />}
          onClick={() => navigate(-1)}
          sx={{ mb: 3 }}
        >
          Back
        </Button>

        <Paper elevation={2} sx={{ p: 4 }}>
          <Typography variant="h3" gutterBottom fontWeight={700}>
            Privacy Policy
          </Typography>
          <Typography variant="caption" color="text.secondary" gutterBottom display="block" sx={{ mb: 4 }}>
            Last updated: {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
          </Typography>

          <Typography variant="h5" gutterBottom fontWeight={600} sx={{ mt: 4 }}>
            1. Information We Collect
          </Typography>
          <Typography paragraph>
            When you use {siteName}, we collect the following information:
          </Typography>
          <Typography component="ul" paragraph>
            <li>Account information (email address, name)</li>
            <li>Resume content and personal information you provide</li>
            <li>Profile images and documents you upload</li>
            <li>Usage data and analytics</li>
          </Typography>

          <Typography variant="h5" gutterBottom fontWeight={600} sx={{ mt: 4 }}>
            2. How We Use Your Information
          </Typography>
          <Typography paragraph>
            We use your information to:
          </Typography>
          <Typography component="ul" paragraph>
            <li>Generate and store your resumes</li>
            <li>Provide AI-powered resume generation services</li>
            <li>Improve our services and user experience</li>
            <li>Send important service updates</li>
          </Typography>

          <Typography variant="h5" gutterBottom fontWeight={600} sx={{ mt: 4 }}>
            3. Data Storage and Security
          </Typography>
          <Typography paragraph>
            Your data is securely stored on AWS infrastructure using industry-standard encryption. 
            We use Amazon S3 for file storage, DynamoDB for database, and Cognito for authentication. 
            All data transmissions are encrypted using HTTPS.
          </Typography>

          <Typography variant="h5" gutterBottom fontWeight={600} sx={{ mt: 4 }}>
            4. Third-Party Services
          </Typography>
          <Typography paragraph>
            We use the following third-party services:
          </Typography>
          <Typography component="ul" paragraph>
            <li><strong>OpenAI:</strong> For AI-powered resume generation</li>
            <li><strong>Amazon Web Services (AWS):</strong> For hosting and storage</li>
            <li><strong>AWS Cognito:</strong> For user authentication</li>
          </Typography>

          <Typography variant="h5" gutterBottom fontWeight={600} sx={{ mt: 4 }}>
            5. Your Rights
          </Typography>
          <Typography paragraph>
            You have the right to:
          </Typography>
          <Typography component="ul" paragraph>
            <li>Access your personal data</li>
            <li>Delete your account and data</li>
            <li>Export your resumes</li>
            <li>Opt-out of communications</li>
          </Typography>

          <Typography variant="h5" gutterBottom fontWeight={600} sx={{ mt: 4 }}>
            6. Data Retention
          </Typography>
          <Typography paragraph>
            We retain your data as long as your account is active. When you delete your account, 
            we permanently delete all your personal information and resumes within 30 days.
          </Typography>

          <Typography variant="h5" gutterBottom fontWeight={600} sx={{ mt: 4 }}>
            7. Cookies
          </Typography>
          <Typography paragraph>
            We use essential cookies for authentication and session management. We also use 
            localStorage to save your theme preferences.
          </Typography>

          <Typography variant="h5" gutterBottom fontWeight={600} sx={{ mt: 4 }}>
            8. Children's Privacy
          </Typography>
          <Typography paragraph>
            Our service is not intended for children under 13 years of age. We do not knowingly 
            collect personal information from children under 13.
          </Typography>

          <Typography variant="h5" gutterBottom fontWeight={600} sx={{ mt: 4 }}>
            9. Changes to This Policy
          </Typography>
          <Typography paragraph>
            We may update this privacy policy from time to time. We will notify you of any changes 
            by posting the new privacy policy on this page.
          </Typography>

          <Typography variant="h5" gutterBottom fontWeight={600} sx={{ mt: 4 }}>
            10. Contact Us
          </Typography>
          <Typography paragraph>
            If you have any questions about this privacy policy, please contact us at:
            <br />
            <strong>Email:</strong> {privacyEmail}
          </Typography>
        </Paper>
      </Container>
    </Box>
  );
};

export default Privacy;

